import { useContext } from "react";
import dataApplicationsContext from "../../context/dataApplicationsContext";
import { useNavigate } from "react-router-dom";

const RightPartContent = ({  }) => {
  const { windowWidth } = useContext(dataApplicationsContext);

  const handleNavigate = () => {
    window.open(`${process.env.REACT_APP_FRONT_URL_APP}/contact`, '_blank');
  }

  if (windowWidth >= 1021) {
    return (
      <div className="help-right-part">
        <p className="fw-600 fz-18 mb-8">Besoin de nous joindre ?</p>
        <p className="fw-500 fz-15">Commençons par quelques questions afin de mieux vous orienter.</p>
        <button className="contact-btn" onClick={handleNavigate}>Contacter-nous</button>
        {/* <p className="fw-500 fz-14">Vous pouvez également nous envoyer vos remarques.</p> */}
      </div>
    )
  } else {
    return null
  }
}

export default RightPartContent